import React from "react";
import Div100vh from "react-div-100vh";
import Lottie from "lottie-react";
import ProcessingAnimation from "@/assets/lottie/processing-animation.json";

export default function ProcessingScreen() {
  return (
    <Div100vh className="flex flex-col justify-center items-center py-5 px-4 bg-custom-bg-color">
      <div className="flex flex-col">
        <Lottie animationData={ProcessingAnimation} loop={true} />
        <div className="flex flex-col gap-6 items-start pl-4 mt-20">
          <div className="flex flex-col">
            <span className="font-bold">Hey,</span>
            <span>Good things are worth the wait.</span>
          </div>
          <span className="text-custom-primary-color font-medium">
            We are having a look at your profile
          </span>
        </div>
      </div>
    </Div100vh>
  );
}
